import React, { ReactNode } from 'react';

import * as S from './styles';

interface IProps {
  children: ReactNode;
  className?: string;
  style?: object;
}

/**
 * The strip above a table — search on the left, filters and actions on the
 * right.
 *
 *   <PanelBoxLayout className="flush" contentStyle={{ padding: 0 }}>
 *     <Toolbar>
 *       <SearchBox ... />
 *       <ToolbarRight><FilterPopup /></ToolbarRight>
 *     </Toolbar>
 *     <AppTable ... />
 *   </PanelBoxLayout>
 */
const Toolbar: React.FC<IProps> = ({ children, className, style }) => (
  <S.Toolbar className={className} style={style}>
    {children}
  </S.Toolbar>
);

export const ToolbarRight: React.FC<IProps> = ({ children, className, style }) => (
  <S.Right className={className} style={style}>
    {children}
  </S.Right>
);

export default Toolbar;
